import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Link } from '../components/localizedlink'
import ExternalLink from '../images/svg-icons/external-link-regular.svg'
import logo from '../images/logo.svg'


const HeaderOnline = ({ navigation, locale, active, className }) => {
  const [open, setOpen] = useState(false);

  const toggleMenu = useCallback((e) => {
    e.preventDefault();
    setOpen(value => !value);
  }, []);

  useEffect(() => {
    if (open && !active) {
      setOpen(false);
    }
  }, [open, active]);

  return (
    <div className={`header-online ${open ? 'header-online--menu-open' : ''}${active ? ' active': ''}${className ? ` ${className}`: ''}`}>
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className="d-none d-lg-block">
              <div className="header-online__translations">
                <Link className="header-online__live" to="/">
                  <FormattedMessage id="go-live-site" />
                </Link>
                <Link className={`header-online__translations__link ${locale === 'it' ? 'header-online__translations__link--active' : ''}`} literal="true" to="/online/">
                  IT
                </Link>
                <span>/</span>
                <Link className={`header-online__translations__link ${locale === 'en' ? 'header-online__translations__link--active' : ''}`} literal="true" to="/en/online/">
                  EN
                </Link>
              </div>
            </div>
          </div>
          <div className="col-sm-12 d-lg-flex align-items-end">
            <div className="logo">
              <Link className="logo__link" to="/online/">
                <img src={logo} alt="Intranet Italia Day" className="logo__img" />
                <div className="logo__name visuallyhidden"><strong>INTRANET ITALIA DAY</strong></div>
              </Link>
              <span className="logo__date"><FormattedMessage id="online-dates" /></span>
            </div>
            <a href="/" title="Mostra/Nascondi menu" onClick={toggleMenu}
              className={`hamburger ml-auto ${open ? 'open' : ''}`} >
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </a>
            {!!navigation.headerOnline && (
              <nav className="nav" itemType="http://schema.org/SiteNavigationElement" itemScope="itemscope" role="navigation"
                style={{ display: open ? 'block' : 'none' }}>
                {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role */}
                <ul className="navigation" role="menu" aria-orientation="horizontal">
                  <li className="navigation__item d-lg-none">
                    <div className="navigation__translations">
                      <Link className={`navigation__translation__link ${locale === 'it' ? 'navigation__translation__link--active' : ''}`} literal="true" to="/online/">
                        IT
                      </Link>
                      <span className="mr-2">/</span>
                      <Link className={`navigation__translation__link ${locale === 'en' ? 'navigation__translation__link--active' : ''}`} literal="true" to="/en/online/">
                        EN
                      </Link>
                    </div>
                  </li>
                  {navigation.headerOnline.map((item, i) => (
                    <li className={`navigation__item ${i === 0 ? 'navigation__item--first' : ''}`} itemProp="name" key={i}>
                      {item.link && (
                        <Link to={item.link} onClick={(e) => setOpen(false)} title={item.title || item.name} className="navigation__link" 
                          role="menuitem" itemProp="url">
                          {item.name}
                        </Link>
                      )}
                    </li>
                  ))}
                 
                  <li className="navigation__item d-lg-none">
                    <Link className="header-online__live" to="/">
                      <FormattedMessage id="go-live-site" />
                      <span className="ico-svg"><ExternalLink /></span>
                    </Link>
                  </li>
                </ul>
              </nav>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

HeaderOnline.propTypes = {
  siteTitle: PropTypes.string,
}

HeaderOnline.defaultProps = {
  siteTitle: ``,
}

export default HeaderOnline;
